'use strict'

const { createYConnection } = require('../../../functions/createYConnection')

class rmChat {

    constructor ($scope, $rootScope, $timeout, [$element], $mdDialog, $http) {
        this.$scope = $scope
        this.$rootScope = $rootScope
        this.$timeout = $timeout
        this.$element = $element
        this.$mdDialog = $mdDialog
        this.$http = $http

        this.yObserve = this.yObserve.bind(this)
        this.yObserveUsers = this.yObserveUsers.bind(this)
        this.onScroll = this.onScroll.bind(this)

        this.scrollContainer = $element.querySelector('.rm-chat-container')
        this.stationId = $scope.stationId || window.CONFIG.station_id
        this.userId = window.CONFIG.user_id
        this.yMessages = null
        this.yUsersLive = []
        this.isDown = true
        this.resetModel()
        this.oldMessagesCount = 0

        this.scrollContainer.addEventListener('scroll', this.onScroll)

        if ($scope.typeId) {
            createYConnection(this.getYjsRoomName())
                .then(this.initRmChat.bind(this))
        }

        $scope.$on('$destroy', () => {
            const { scrollContainer, yMessages, yObserve, yDoc } = this
            scrollContainer.removeEventListener('scroll', this.onScroll)

            if (yMessages) {
                yMessages.unobserve(yObserve)
            }

            if (yDoc) {
                yDoc.provider.awareness.on('change', this.yObserveUsers)
                yDoc.provider.destroy()
                yDoc.destroy()
            }

        })

        this.initSizable()
    }

    initSizable () {
        let [sideLeft] = document.getElementsByClassName('rundown-right-side-container')
        let handler = document.querySelector('.handler.left')

        // save the position of the rect and watch it. Only start the watch when the mouse is down
        let unregisterSideRightPosWatch = null, sideRightPos = 0

        const registerSideRightPosWatch = () => {
            sideRightPos = sideLeft.getBoundingClientRect().right
            unregisterSideRightPosWatch = this.$scope.$watch(() => {
                return sideLeft.getBoundingClientRect().right
            }, (newSize, oldSize) => {
                if (newSize !== oldSize) {
                    sideRightPos = newSize
                }
            })
        }

        // Prevent the select action
        this.movingSide = false

        handler.addEventListener('mousedown', event => {
            event.preventDefault()
            this.movingSide = true
            sideLeft.classList.remove('rundown-side-trans')

            if (unregisterSideRightPosWatch) {
                unregisterSideRightPosWatch()
                unregisterSideRightPosWatch = null
            }

            registerSideRightPosWatch()
            document.addEventListener('mousemove', move)
            document.addEventListener('mouseup', up)
        })

        let setSidebarWidth = event => {
            let newWidth = sideRightPos - (event.clientX)
            newWidth = newWidth > 249 ? newWidth : 249
            let newMaxWidth = document.querySelector('.content-container').offsetWidth
            sideLeft.style.setProperty('--rundown-right-side-container-max-width', newMaxWidth - 425 + 'px')
            sideLeft.style.setProperty('--rundown-right-side-container-width', newWidth + 'px')
        }

        let move = event => {
            event.preventDefault()
            if (this.movingSide) {
                setSidebarWidth(event)
            }
        }

        let up = event => {
            this.movingSide = false
            setSidebarWidth(event)
            sideLeft.classList.add('rundown-side-trans')

            if (unregisterSideRightPosWatch) {
                unregisterSideRightPosWatch()
                unregisterSideRightPosWatch = null
            }
            document.removeEventListener('mousemove', move)
            document.removeEventListener('mouseup', up)
        }

    }

    isNewUser (userId, index) {
        if (this.prevUserId != userId || index === 0) {
            this.prevUserId = userId
            return true
        }
        return false
    }

    getDate (dateTime) {
        return dateTime !== 'now'
            ? new Date(dateTime)
            : new Date()
    }

    isNewDay (createdAt, index) {
        let dateTime = this.getDate(createdAt)
        let day = dateTime.getDay() + '.' + dateTime.getMonth()

        if (this.prevDay != day || index === 0) {
            this.prevDay = day
            return true
        }

        return false
    }

    isOld (dateTime, index) {
        let newTime = this.getDate(dateTime).getTime()

        if (index === 0 || (newTime - this.prevTime) / 60000 > 1) {
            this.prevTime = newTime
            return true
        }

        return false
    }

    resetModel () {
        this.model = ''
    }

    sendMessage () {
        const {
            yMessages,
            userId,
            model,
            $scope,
            $http,
        } = this

        // Trim all starting and ending br, spaces and enters
        const parsedModel = model.replace(/^(<br(\s*\/?>)|\s|\n)+|(<br(\s*\/?>)|\s|\n)+$/g, '')
        if (parsedModel === '') {
            return
        }

        if (parsedModel.replace(/<br[^>]*>?/g, '\n').length > 1000) {
            this.$mdDialog.show(
                this.$mdDialog.alert({
                    multiple: true,
                    title: $scope.alertTitle,
                    textContent: $scope.alertTextContent,
                    ok: $scope.alertClose,
                })
            ).catch(() => {
            })
            return
        }

        const newMessage = {
            message: parsedModel,
            user_id: userId,
            program_id: $scope.typeId,
        }

        $http.post(
            `/chat-messages/send`,
            newMessage,
        )

        yMessages.push([Object.assign(newMessage, {
            user: { name: window.CONFIG.user_name },
        })])

        this.isDown = true
        this.resetModel()
        this.scrollDown()
    }

    getYjsRoomName () {

        const {
            stationId,
            $scope: {
                type,
                typeId,
            },
        } = this

        return `chat.${stationId}.${type}.${typeId}`
    }

    thisIsMineAwareness (userId) {
        return this.yDoc.clientID === userId
    }

    createUpdateUser (userId, userData) {
        if (this.thisIsMineAwareness(userId)) return

        if (!this.yUsersLive.includes(userId)) {
            userData.id = userId
            this.$rootScope.$broadcast('rm_chat_liveUserAdd', this.getYjsRoomName(), userId, userData)
            this.yUsersLive.push(userId)
        }
    }

    removeUser (userId, userData) {
        if (this.thisIsMineAwareness(userId)) return

        const index = this.yUsersLive.indexOf(userId)
        if (index > -1) {
            this.yUsersLive.splice(index, 1)
        }
        this.$rootScope.$broadcast('rm_chat_liveUserDelete', this.getYjsRoomName(), userId, userData)
    }

    initRmChat (yDoc) {
        const yMessages = yDoc.getArray('messages')
        // const yUsersLive = yDoc.getMap('usersLive');

        this.yMessages = yMessages
        // this.yUsersLive = yUsersLive;
        this.yDoc = yDoc

        yMessages.observe(this.yObserve)

        yDoc.provider.awareness.on('change', this.yObserveUsers)
        yDoc.provider.awareness.states.forEach((state, id) => {
            this.createUpdateUser(id, state.user)
        })

    }

    fixScrollDown () {
        let messagesCount = this.yMessages
            ? this.yMessages.length
            : 0

        if (this.oldMessagesCount !== messagesCount) {
            this.oldMessagesCount = messagesCount
            this.scrollDown()
        }
    }

    scrollDown () {
        const {
            isDown,
        } = this

        if (isDown) {
            let scrollTo = this.scrollContainer.scrollHeight + this.scrollContainer.offsetHeight
            $(this.scrollContainer).animate({ scrollTop: scrollTo }, 'slow')
        }
    }

    yObserve () {
        this.$timeout(() => {
            this.$scope.$apply()
        })
        let messagesCount = this.yMessages
            ? this.yMessages.length
            : 0

        if ((this.oldMessagesCount !== undefined) && (this.oldMessagesCount !== messagesCount)) {
            this.oldMessagesCount = messagesCount
            this.$rootScope.$broadcast('rm_chat_newMessage', this.getYjsRoomName())
        }
    }

    yObserveUsers (event) {
        for (const key of event.added) {
            const user = this.yDoc.provider.awareness.states.get(key)
            this.createUpdateUser(key, user.user)
        }
        for (const key of event.updated) {
            const user = this.yDoc.provider.awareness.states.get(key)
            this.createUpdateUser(key, user.user)
        }
        for (const key of event.removed) {
            this.removeUser(key)
        }
    }

    onScroll (event) {
        /** @var HTMLElement */
        let elem = event.target
        this.isDown = elem.scrollTop + elem.offsetHeight === elem.scrollHeight
    }

}

module.exports = [() => {
    return {
        templateUrl: '/partial/app.partials.app.rm_chat',
        controller: [
            '$scope',
            '$rootScope',
            '$timeout',
            '$element',
            '$mdDialog',
            '$http',
            rmChat,
        ],
        controllerAs: 'ctrl',
        scope: {
            type: '=',
            typeId: '=',
            stationId: '=',
            zngSubmit: '&',
        },
    }
}]
